/*! Tripetto Services 1.2.1 - Copyright (C) 2020 Tripetto B.V. - All Rights Reserved */
module.exports = function (t) {
  var e = {};

  function r(n) {
    if (e[n]) return e[n].exports;
    var o = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = t, r.c = e, r.d = function (t, e, n) {
    r.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, r.t = function (t, e) {
    if (1 & e && (t = r(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      r.d(n, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return r.d(e, "a", e), e;
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.p = "", r(r.s = 10);
}([function (t, e, r) {
  t.exports = r(11).Promise;
}, function (t, e, r) {
  "use strict";

  r.r(e), function (t) {
    r.d(e, "__extends", function () {
      return o;
    }), r.d(e, "__assign", function () {
      return _i;
    }), r.d(e, "__rest", function () {
      return s;
    }), r.d(e, "__decorate", function () {
      return a;
    }), r.d(e, "__param", function () {
      return u;
    }), r.d(e, "__metadata", function () {
      return c;
    }), r.d(e, "__awaiter", function () {
      return l;
    }), r.d(e, "__generator", function () {
      return f;
    }), r.d(e, "__createBinding", function () {
      return p;
    }), r.d(e, "__exportStar", function () {
      return h;
    }), r.d(e, "__values", function () {
      return d;
    }), r.d(e, "__read", function () {
      return y;
    }), r.d(e, "__spread", function () {
      return m;
    }), r.d(e, "__spreadArrays", function () {
      return b;
    }), r.d(e, "__await", function () {
      return v;
    }), r.d(e, "__asyncGenerator", function () {
      return _;
    }), r.d(e, "__asyncDelegator", function () {
      return g;
    }), r.d(e, "__asyncValues", function () {
      return w;
    }), r.d(e, "__makeTemplateObject", function () {
      return T;
    }), r.d(e, "__importStar", function () {
      return O;
    }), r.d(e, "__importDefault", function () {
      return S;
    }), r.d(e, "__classPrivateFieldGet", function () {
      return j;
    }), r.d(e, "__classPrivateFieldSet", function () {
      return A;
    });

    var _n = function n(t, e) {
      return (_n = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (t, e) {
        t.__proto__ = e;
      } || function (t, e) {
        for (var r in e) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
      })(t, e);
    };

    function o(t, e) {
      function r() {
        this.constructor = t;
      }

      _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
    }

    var _i = function i() {
      return (_i = Object.assign || function (t) {
        for (var e, r = 1, n = arguments.length; r < n; r++) {
          for (var o in e = arguments[r]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      }).apply(this, arguments);
    };

    function s(t, e) {
      var r = {};

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
      }

      if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
          e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
        }
      }

      return r;
    }

    function a(t, e, r, n) {
      var o,
          i = arguments.length,
          s = i < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) s = Reflect.decorate(t, e, r, n);else for (var a = t.length - 1; a >= 0; a--) {
        (o = t[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, r, s) : o(e, r)) || s);
      }
      return i > 3 && s && Object.defineProperty(e, r, s), s;
    }

    function u(t, e) {
      return function (r, n) {
        e(r, n, t);
      };
    }

    function c(t, e) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
    }

    function l(e, r, n, o) {
      return new (n || (n = t))(function (t, i) {
        function s(t) {
          try {
            u(o.next(t));
          } catch (t) {
            i(t);
          }
        }

        function a(t) {
          try {
            u(o.throw(t));
          } catch (t) {
            i(t);
          }
        }

        function u(e) {
          var r;
          e.done ? t(e.value) : (r = e.value, r instanceof n ? r : new n(function (t) {
            t(r);
          })).then(s, a);
        }

        u((o = o.apply(e, r || [])).next());
      });
    }

    function f(t, e) {
      var r,
          n,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, n = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = s.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = e.call(t, s);
              } catch (t) {
                i = [6, t], n = 0;
              } finally {
                r = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    }

    var p = Object.create ? function (t, e, r, n) {
      void 0 === n && (n = r), Object.defineProperty(t, n, {
        enumerable: !0,
        get: function get() {
          return e[r];
        }
      });
    } : function (t, e, r, n) {
      void 0 === n && (n = r), t[n] = e[r];
    };

    function h(t, e) {
      for (var r in t) {
        "default" === r || Object.prototype.hasOwnProperty.call(e, r) || p(e, t, r);
      }
    }

    function d(t) {
      var e = "function" == typeof Symbol && Symbol.iterator,
          r = e && t[e],
          n = 0;
      if (r) return r.call(t);
      if (t && "number" == typeof t.length) return {
        next: function next() {
          return t && n >= t.length && (t = void 0), {
            value: t && t[n++],
            done: !t
          };
        }
      };
      throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function y(t, e) {
      var r = "function" == typeof Symbol && t[Symbol.iterator];
      if (!r) return t;
      var n,
          o,
          i = r.call(t),
          s = [];

      try {
        for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
          s.push(n.value);
        }
      } catch (t) {
        o = {
          error: t
        };
      } finally {
        try {
          n && !n.done && (r = i.return) && r.call(i);
        } finally {
          if (o) throw o.error;
        }
      }

      return s;
    }

    function m() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t = t.concat(y(arguments[e]));
      }

      return t;
    }

    function b() {
      for (var t = 0, e = 0, r = arguments.length; e < r; e++) {
        t += arguments[e].length;
      }

      var n = Array(t),
          o = 0;

      for (e = 0; e < r; e++) {
        for (var i = arguments[e], s = 0, a = i.length; s < a; s++, o++) {
          n[o] = i[s];
        }
      }

      return n;
    }

    function v(t) {
      return this instanceof v ? (this.v = t, this) : new v(t);
    }

    function _(e, r, n) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var o,
          i = n.apply(e, r || []),
          s = [];
      return o = {}, a("next"), a("throw"), a("return"), o[Symbol.asyncIterator] = function () {
        return this;
      }, o;

      function a(e) {
        i[e] && (o[e] = function (r) {
          return new t(function (t, n) {
            s.push([e, r, t, n]) > 1 || u(e, r);
          });
        });
      }

      function u(e, r) {
        try {
          (n = i[e](r)).value instanceof v ? t.resolve(n.value.v).then(c, l) : f(s[0][2], n);
        } catch (t) {
          f(s[0][3], t);
        }

        var n;
      }

      function c(t) {
        u("next", t);
      }

      function l(t) {
        u("throw", t);
      }

      function f(t, e) {
        t(e), s.shift(), s.length && u(s[0][0], s[0][1]);
      }
    }

    function g(t) {
      var e, r;
      return e = {}, n("next"), n("throw", function (t) {
        throw t;
      }), n("return"), e[Symbol.iterator] = function () {
        return this;
      }, e;

      function n(n, o) {
        e[n] = t[n] ? function (e) {
          return (r = !r) ? {
            value: v(t[n](e)),
            done: "return" === n
          } : o ? o(e) : e;
        } : o;
      }
    }

    function w(e) {
      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var r,
          n = e[Symbol.asyncIterator];
      return n ? n.call(e) : (e = d(e), r = {}, o("next"), o("throw"), o("return"), r[Symbol.asyncIterator] = function () {
        return this;
      }, r);

      function o(n) {
        r[n] = e[n] && function (r) {
          return new t(function (o, i) {
            (function (e, r, n, o) {
              t.resolve(o).then(function (t) {
                e({
                  value: t,
                  done: n
                });
              }, r);
            })(o, i, (r = e[n](r)).done, r.value);
          });
        };
      }
    }

    function T(t, e) {
      return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
      }) : t.raw = e, t;
    }

    var E = Object.create ? function (t, e) {
      Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
      });
    } : function (t, e) {
      t.default = e;
    };

    function O(t) {
      if (t && t.__esModule) return t;
      var e = {};
      if (null != t) for (var r in t) {
        "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && p(e, t, r);
      }
      return E(e, t), e;
    }

    function S(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function j(t, e) {
      if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
      return e.get(t);
    }

    function A(t, e, r) {
      if (!e.has(t)) throw new TypeError("attempted to set private field on non-instance");
      return e.set(t, r), r;
    }
  }.call(this, r(0));
}, function (t, e, r) {
  "use strict";

  function n(t) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  var o;
  "undefined" != typeof window ? o = window : "undefined" == typeof self ? (console.warn("Using browser-only version of superagent in non-browser environment"), o = void 0) : o = self;
  var i = r(17),
      s = r(18),
      a = r(19),
      u = r(22),
      c = r(8),
      l = r(23),
      f = r(25);

  function p() {}

  t.exports = function (t, r) {
    return "function" == typeof r ? new e.Request("GET", t).end(r) : 1 === arguments.length ? new e.Request("GET", t) : new e.Request(t, r);
  };

  var h = e = t.exports;
  e.Request = g, h.getXHR = function () {
    if (o.XMLHttpRequest && (!o.location || "file:" !== o.location.protocol || !o.ActiveXObject)) return new XMLHttpRequest();

    try {
      return new ActiveXObject("Microsoft.XMLHTTP");
    } catch (t) {}

    try {
      return new ActiveXObject("Msxml2.XMLHTTP.6.0");
    } catch (t) {}

    try {
      return new ActiveXObject("Msxml2.XMLHTTP.3.0");
    } catch (t) {}

    try {
      return new ActiveXObject("Msxml2.XMLHTTP");
    } catch (t) {}

    throw new Error("Browser-only version of superagent could not find XHR");
  };
  var d = "".trim ? function (t) {
    return t.trim();
  } : function (t) {
    return t.replace(/(^\s*|\s*$)/g, "");
  };

  function y(t) {
    if (!c(t)) return t;
    var e = [];

    for (var r in t) {
      Object.prototype.hasOwnProperty.call(t, r) && m(e, r, t[r]);
    }

    return e.join("&");
  }

  function m(t, e, r) {
    if (void 0 !== r) if (null !== r) {
      if (Array.isArray(r)) r.forEach(function (r) {
        m(t, e, r);
      });else if (c(r)) for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && m(t, "".concat(e, "[").concat(n, "]"), r[n]);
      } else t.push(encodeURI(e) + "=" + encodeURIComponent(r));
    } else t.push(encodeURI(e));
  }

  function b(t) {
    for (var e, r, n = {}, o = t.split("&"), i = 0, s = o.length; i < s; ++i) {
      -1 === (r = (e = o[i]).indexOf("=")) ? n[decodeURIComponent(e)] = "" : n[decodeURIComponent(e.slice(0, r))] = decodeURIComponent(e.slice(r + 1));
    }

    return n;
  }

  function v(t) {
    return /[/+]json($|[^-\w])/i.test(t);
  }

  function _(t) {
    this.req = t, this.xhr = this.req.xhr, this.text = "HEAD" !== this.req.method && ("" === this.xhr.responseType || "text" === this.xhr.responseType) || void 0 === this.xhr.responseType ? this.xhr.responseText : null, this.statusText = this.req.xhr.statusText;
    var e = this.xhr.status;
    1223 === e && (e = 204), this._setStatusProperties(e), this.headers = function (t) {
      for (var e, r, n, o, i = t.split(/\r?\n/), s = {}, a = 0, u = i.length; a < u; ++a) {
        -1 !== (e = (r = i[a]).indexOf(":")) && (n = r.slice(0, e).toLowerCase(), o = d(r.slice(e + 1)), s[n] = o);
      }

      return s;
    }(this.xhr.getAllResponseHeaders()), this.header = this.headers, this.header["content-type"] = this.xhr.getResponseHeader("content-type"), this._setHeaderProperties(this.header), null === this.text && t._responseType ? this.body = this.xhr.response : this.body = "HEAD" === this.req.method ? null : this._parseBody(this.text ? this.text : this.xhr.response);
  }

  function g(t, e) {
    var r = this;
    this._query = this._query || [], this.method = t, this.url = e, this.header = {}, this._header = {}, this.on("end", function () {
      var t,
          e = null,
          n = null;

      try {
        n = new _(r);
      } catch (t) {
        return (e = new Error("Parser is unable to parse the response")).parse = !0, e.original = t, r.xhr ? (e.rawResponse = void 0 === r.xhr.responseType ? r.xhr.responseText : r.xhr.response, e.status = r.xhr.status ? r.xhr.status : null, e.statusCode = e.status) : (e.rawResponse = null, e.status = null), r.callback(e);
      }

      r.emit("response", n);

      try {
        r._isResponseOK(n) || (t = new Error(n.statusText || n.text || "Unsuccessful HTTP response"));
      } catch (e) {
        t = e;
      }

      t ? (t.original = e, t.response = n, t.status = n.status, r.callback(t, n)) : r.callback(null, n);
    });
  }

  function w(t, e, r) {
    var n = h("DELETE", t);
    return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n;
  }

  h.serializeObject = y, h.parseString = b, h.types = {
    html: "text/html",
    json: "application/json",
    xml: "text/xml",
    urlencoded: "application/x-www-form-urlencoded",
    form: "application/x-www-form-urlencoded",
    "form-data": "application/x-www-form-urlencoded"
  }, h.serialize = {
    "application/x-www-form-urlencoded": a.stringify,
    "application/json": s
  }, h.parse = {
    "application/x-www-form-urlencoded": b,
    "application/json": JSON.parse
  }, l(_.prototype), _.prototype._parseBody = function (t) {
    var e = h.parse[this.type];
    return this.req._parser ? this.req._parser(this, t) : (!e && v(this.type) && (e = h.parse["application/json"]), e && t && (t.length > 0 || t instanceof Object) ? e(t) : null);
  }, _.prototype.toError = function () {
    var t = this.req,
        e = t.method,
        r = t.url,
        n = "cannot ".concat(e, " ").concat(r, " (").concat(this.status, ")"),
        o = new Error(n);
    return o.status = this.status, o.method = e, o.url = r, o;
  }, h.Response = _, i(g.prototype), u(g.prototype), g.prototype.type = function (t) {
    return this.set("Content-Type", h.types[t] || t), this;
  }, g.prototype.accept = function (t) {
    return this.set("Accept", h.types[t] || t), this;
  }, g.prototype.auth = function (t, e, r) {
    1 === arguments.length && (e = ""), "object" === n(e) && null !== e && (r = e, e = ""), r || (r = {
      type: "function" == typeof btoa ? "basic" : "auto"
    });

    var o = function o(t) {
      if ("function" == typeof btoa) return btoa(t);
      throw new Error("Cannot use basic auth, btoa is not a function");
    };

    return this._auth(t, e, r, o);
  }, g.prototype.query = function (t) {
    return "string" != typeof t && (t = y(t)), t && this._query.push(t), this;
  }, g.prototype.attach = function (t, e, r) {
    if (e) {
      if (this._data) throw new Error("superagent can't mix .send() and .attach()");

      this._getFormData().append(t, e, r || e.name);
    }

    return this;
  }, g.prototype._getFormData = function () {
    return this._formData || (this._formData = new o.FormData()), this._formData;
  }, g.prototype.callback = function (t, e) {
    if (this._shouldRetry(t, e)) return this._retry();
    var r = this._callback;
    this.clearTimeout(), t && (this._maxRetries && (t.retries = this._retries - 1), this.emit("error", t)), r(t, e);
  }, g.prototype.crossDomainError = function () {
    var t = new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");
    t.crossDomain = !0, t.status = this.status, t.method = this.method, t.url = this.url, this.callback(t);
  }, g.prototype.agent = function () {
    return console.warn("This is not supported in browser version of superagent"), this;
  }, g.prototype.ca = g.prototype.agent, g.prototype.buffer = g.prototype.ca, g.prototype.write = function () {
    throw new Error("Streaming is not supported in browser version of superagent");
  }, g.prototype.pipe = g.prototype.write, g.prototype._isHost = function (t) {
    return t && "object" === n(t) && !Array.isArray(t) && "[object Object]" !== Object.prototype.toString.call(t);
  }, g.prototype.end = function (t) {
    this._endCalled && console.warn("Warning: .end() was called twice. This is not supported in superagent"), this._endCalled = !0, this._callback = t || p, this._finalizeQueryString(), this._end();
  }, g.prototype._setUploadTimeout = function () {
    var t = this;
    this._uploadTimeout && !this._uploadTimeoutTimer && (this._uploadTimeoutTimer = setTimeout(function () {
      t._timeoutError("Upload timeout of ", t._uploadTimeout, "ETIMEDOUT");
    }, this._uploadTimeout));
  }, g.prototype._end = function () {
    if (this._aborted) return this.callback(new Error("The request has been aborted even before .end() was called"));
    var t = this;
    this.xhr = h.getXHR();
    var e = this.xhr,
        r = this._formData || this._data;
    this._setTimeouts(), e.onreadystatechange = function () {
      var r = e.readyState;

      if (r >= 2 && t._responseTimeoutTimer && clearTimeout(t._responseTimeoutTimer), 4 === r) {
        var n;

        try {
          n = e.status;
        } catch (t) {
          n = 0;
        }

        if (!n) {
          if (t.timedout || t._aborted) return;
          return t.crossDomainError();
        }

        t.emit("end");
      }
    };

    var n = function n(e, r) {
      r.total > 0 && (r.percent = r.loaded / r.total * 100, 100 === r.percent && clearTimeout(t._uploadTimeoutTimer)), r.direction = e, t.emit("progress", r);
    };

    if (this.hasListeners("progress")) try {
      e.addEventListener("progress", n.bind(null, "download")), e.upload && e.upload.addEventListener("progress", n.bind(null, "upload"));
    } catch (t) {}
    e.upload && this._setUploadTimeout();

    try {
      this.username && this.password ? e.open(this.method, this.url, !0, this.username, this.password) : e.open(this.method, this.url, !0);
    } catch (t) {
      return this.callback(t);
    }

    if (this._withCredentials && (e.withCredentials = !0), !this._formData && "GET" !== this.method && "HEAD" !== this.method && "string" != typeof r && !this._isHost(r)) {
      var o = this._header["content-type"],
          i = this._serializer || h.serialize[o ? o.split(";")[0] : ""];
      !i && v(o) && (i = h.serialize["application/json"]), i && (r = i(r));
    }

    for (var s in this.header) {
      null !== this.header[s] && Object.prototype.hasOwnProperty.call(this.header, s) && e.setRequestHeader(s, this.header[s]);
    }

    this._responseType && (e.responseType = this._responseType), this.emit("request", this), e.send(void 0 === r ? null : r);
  }, h.agent = function () {
    return new f();
  }, ["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (t) {
    f.prototype[t.toLowerCase()] = function (e, r) {
      var n = new h.Request(t, e);
      return this._setDefaults(n), r && n.end(r), n;
    };
  }), f.prototype.del = f.prototype.delete, h.get = function (t, e, r) {
    var n = h("GET", t);
    return "function" == typeof e && (r = e, e = null), e && n.query(e), r && n.end(r), n;
  }, h.head = function (t, e, r) {
    var n = h("HEAD", t);
    return "function" == typeof e && (r = e, e = null), e && n.query(e), r && n.end(r), n;
  }, h.options = function (t, e, r) {
    var n = h("OPTIONS", t);
    return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n;
  }, h.del = w, h.delete = w, h.patch = function (t, e, r) {
    var n = h("PATCH", t);
    return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n;
  }, h.post = function (t, e, r) {
    var n = h("POST", t);
    return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n;
  }, h.put = function (t, e, r) {
    var n = h("PUT", t);
    return "function" == typeof e && (r = e, e = null), e && n.send(e), r && n.end(r), n;
  };
}, function (t, e, r) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.TEST_WEBHOOK = e.TEST_SLACK = e.ATTACHMENT = e.TERMS = e.METRIC = e.TRANSLATION = e.LOCALE = e.FONTS = e.EXPORT = e.TEMPLATE = e.UMD = e.L10N = e.STYLES = e.RESPONSE_SUBMIT = e.RESPONSE_ANNOUNCE = e.SNAPSHOT = e.DEFINITION = e.RUN = e.API = e.DELETE_ACCOUNT = e.KEEP_ALIVE = e.SIGNED_OUT = e.SIGNED_IN = e.SIGN_OUT = e.SIGN_IN = void 0, e.SIGN_IN = "/sign-in", e.SIGN_OUT = "/sign-out", e.SIGNED_IN = "/signed-in", e.SIGNED_OUT = "/signed-out", e.KEEP_ALIVE = "/keep-alive", e.DELETE_ACCOUNT = "/goodbye", e.API = "/api", e.RUN = "/run", e.DEFINITION = e.RUN + "/definition", e.SNAPSHOT = e.RUN + "/snapshot", e.RESPONSE_ANNOUNCE = e.RUN + "/response/announce", e.RESPONSE_SUBMIT = e.RUN + "/response/submit", e.STYLES = e.RUN + "/styles", e.L10N = e.RUN + "/l10n", e.UMD = "/js", e.TEMPLATE = "/template", e.EXPORT = "/export", e.FONTS = "/fonts/", e.LOCALE = "/locale", e.TRANSLATION = "/translation", e.METRIC = "/metric", e.TERMS = "/terms", e.ATTACHMENT = "/attachment", e.TEST_SLACK = "/test/slack", e.TEST_WEBHOOK = "/test/webhook";
}, function (t, e, r) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.HEADER_ATTACHMENT_TOKEN = e.HEADER_TEMPLATE_TOKEN = e.HEADER_RUNNER_TOKEN = void 0, e.HEADER_RUNNER_TOKEN = "Tripetto-Runner-Token", e.HEADER_TEMPLATE_TOKEN = "Tripetto-Template-Token", e.HEADER_ATTACHMENT_TOKEN = "Tripetto-Attachment-Token";
}, function (t, e) {
  t.exports = require("tripetto-runner-foundation");
}, function (t, e, r) {
  "use strict";

  var n = Object.prototype.hasOwnProperty,
      o = Array.isArray,
      i = function () {
    for (var t = [], e = 0; e < 256; ++e) {
      t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
    }

    return t;
  }(),
      s = function s(t, e) {
    for (var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n) {
      void 0 !== t[n] && (r[n] = t[n]);
    }

    return r;
  };

  t.exports = {
    arrayToObject: s,
    assign: function assign(t, e) {
      return Object.keys(e).reduce(function (t, r) {
        return t[r] = e[r], t;
      }, t);
    },
    combine: function combine(t, e) {
      return [].concat(t, e);
    },
    compact: function compact(t) {
      for (var e = [{
        obj: {
          o: t
        },
        prop: "o"
      }], r = [], n = 0; n < e.length; ++n) {
        for (var i = e[n], s = i.obj[i.prop], a = Object.keys(s), u = 0; u < a.length; ++u) {
          var c = a[u],
              l = s[c];
          "object" == typeof l && null !== l && -1 === r.indexOf(l) && (e.push({
            obj: s,
            prop: c
          }), r.push(l));
        }
      }

      return function (t) {
        for (; t.length > 1;) {
          var e = t.pop(),
              r = e.obj[e.prop];

          if (o(r)) {
            for (var n = [], i = 0; i < r.length; ++i) {
              void 0 !== r[i] && n.push(r[i]);
            }

            e.obj[e.prop] = n;
          }
        }
      }(e), t;
    },
    decode: function decode(t, e, r) {
      var n = t.replace(/\+/g, " ");
      if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);

      try {
        return decodeURIComponent(n);
      } catch (t) {
        return n;
      }
    },
    encode: function encode(t, e, r) {
      if (0 === t.length) return t;
      var n = t;
      if ("symbol" == typeof t ? n = Symbol.prototype.toString.call(t) : "string" != typeof t && (n = String(t)), "iso-8859-1" === r) return escape(n).replace(/%u[0-9a-f]{4}/gi, function (t) {
        return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
      });

      for (var o = "", s = 0; s < n.length; ++s) {
        var a = n.charCodeAt(s);
        45 === a || 46 === a || 95 === a || 126 === a || a >= 48 && a <= 57 || a >= 65 && a <= 90 || a >= 97 && a <= 122 ? o += n.charAt(s) : a < 128 ? o += i[a] : a < 2048 ? o += i[192 | a >> 6] + i[128 | 63 & a] : a < 55296 || a >= 57344 ? o += i[224 | a >> 12] + i[128 | a >> 6 & 63] + i[128 | 63 & a] : (s += 1, a = 65536 + ((1023 & a) << 10 | 1023 & n.charCodeAt(s)), o += i[240 | a >> 18] + i[128 | a >> 12 & 63] + i[128 | a >> 6 & 63] + i[128 | 63 & a]);
      }

      return o;
    },
    isBuffer: function isBuffer(t) {
      return !(!t || "object" != typeof t) && !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
    },
    isRegExp: function isRegExp(t) {
      return "[object RegExp]" === Object.prototype.toString.call(t);
    },
    maybeMap: function maybeMap(t, e) {
      if (o(t)) {
        for (var r = [], n = 0; n < t.length; n += 1) {
          r.push(e(t[n]));
        }

        return r;
      }

      return e(t);
    },
    merge: function t(e, r, i) {
      if (!r) return e;

      if ("object" != typeof r) {
        if (o(e)) e.push(r);else {
          if (!e || "object" != typeof e) return [e, r];
          (i && (i.plainObjects || i.allowPrototypes) || !n.call(Object.prototype, r)) && (e[r] = !0);
        }
        return e;
      }

      if (!e || "object" != typeof e) return [e].concat(r);
      var a = e;
      return o(e) && !o(r) && (a = s(e, i)), o(e) && o(r) ? (r.forEach(function (r, o) {
        if (n.call(e, o)) {
          var s = e[o];
          s && "object" == typeof s && r && "object" == typeof r ? e[o] = t(s, r, i) : e.push(r);
        } else e[o] = r;
      }), e) : Object.keys(r).reduce(function (e, o) {
        var s = r[o];
        return n.call(e, o) ? e[o] = t(e[o], s, i) : e[o] = s, e;
      }, a);
    }
  };
}, function (t, e, r) {
  "use strict";

  var n = String.prototype.replace,
      o = /%20/g,
      i = r(6),
      s = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  t.exports = i.assign({
    default: s.RFC3986,
    formatters: {
      RFC1738: function RFC1738(t) {
        return n.call(t, o, "+");
      },
      RFC3986: function RFC3986(t) {
        return String(t);
      }
    }
  }, s);
}, function (t, e, r) {
  "use strict";

  function n(t) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  t.exports = function (t) {
    return null !== t && "object" === n(t);
  };
}, function (t, e, r) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.noCacheUrl = void 0;
  var n = r(5);

  e.noCacheUrl = function (t, e) {
    return t + (-1 === t.indexOf("?") ? "?" : "&") + n.SHA2.SHA2_256(e).substr(0, 20);
  };
}, function (t, e, r) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var n = r(1),
      o = r(5),
      i = r(15),
      s = r(16),
      a = r(26),
      u = r(27),
      c = r(28),
      l = r(29),
      f = r(30),
      p = function () {
    function t(t) {
      this.token = t.token || "", this.url = "string" == typeof t.url ? t.url : i.URL, this.filestoreUrl = t.filestoreUrl || i.FILESTORE_URL;
    }

    return t.assert = function () {
      if (!this.services) throw new Error("Services are not initialized.");
      return this.services;
    }, t.init = function (e) {
      return t.services = new t(e);
    }, t.internal = function (e) {
      return new t(n.__assign(n.__assign({}, e), {
        url: ""
      }));
    }, Object.defineProperty(t, "definition", {
      get: function get() {
        return t.assert().definition;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "style", {
      get: function get() {
        return t.assert().styles;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t, "onAttachment", {
      get: function get() {
        return t.assert().attachments;
      },
      enumerable: !1,
      configurable: !0
    }), t.onFinish = function (e, r, n) {
      t.assert().onSubmit(e, r || "", n || "");
    }, t.prototype.requireToken = function () {
      if (!this.token) throw new Error("Token is required, but not available.");
      return this.token;
    }, t.prototype.onAttachmentGet = function (t) {
      return f.downloadFile(this.filestoreUrl, this.requireToken(), t);
    }, t.prototype.onAttachmentPut = function (t, e) {
      return f.uploadFile(this.filestoreUrl, this.requireToken(), t, e);
    }, t.prototype.onAttachmentDelete = function (t) {
      return f.deleteFile(this.filestoreUrl, this.requireToken(), t);
    }, Object.defineProperty(t.prototype, "definition", {
      get: function get() {
        return s.getDefinition(this.url, this.requireToken());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "snapshot", {
      get: function get() {
        return a.getSnapshot(this.url, this.requireToken());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "styles", {
      get: function get() {
        return s.getStyles(this.url, this.requireToken());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "l10n", {
      get: function get() {
        return s.getL10n(this.url, this.requireToken());
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attachments", {
      get: function get() {
        var t = this;
        return {
          get: function get(e) {
            return t.onAttachmentGet(e);
          },
          put: function put(e, r) {
            return t.onAttachmentPut(e, r);
          },
          delete: function _delete(e) {
            return t.onAttachmentDelete(e);
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "locale", {
      get: function get() {
        var t = this;
        return function (e) {
          return u.getLocale(t.url, e);
        };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "translations", {
      get: function get() {
        var t = this;
        return function (e, r) {
          return c.getTranslation(t.url, e, r);
        };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "onSubmit", {
      get: function get() {
        var t = this;
        return function (e, r, n, i) {
          return l.submitResponse(t.url, t.requireToken(), o.Export.exportables(e), o.Export.actionables(e), r, n, i || "");
        };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "onPause", {
      get: function get() {
        var t = this;
        return {
          recipe: "email",
          onPause: function onPause(e, r, n, o, i) {
            return a.saveSnapshot(t.url, t.requireToken(), r, e, n, o, i);
          }
        };
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }();

  e.default = p;
}, function (t, e, r) {
  (function (e, n) {
    var o;
    o = function o() {
      "use strict";

      function t(t) {
        return "function" == typeof t;
      }

      var o = Array.isArray ? Array.isArray : function (t) {
        return "[object Array]" === Object.prototype.toString.call(t);
      },
          i = 0,
          s = void 0,
          a = void 0,
          u = function u(t, e) {
        y[i] = t, y[i + 1] = e, 2 === (i += 2) && (a ? a(m) : w());
      },
          c = "undefined" != typeof window ? window : void 0,
          l = c || {},
          f = l.MutationObserver || l.WebKitMutationObserver,
          p = "undefined" == typeof self && void 0 !== e && "[object process]" === {}.toString.call(e),
          h = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;

      function d() {
        var t = setTimeout;
        return function () {
          return t(m, 1);
        };
      }

      var y = new Array(1e3);

      function m() {
        for (var t = 0; t < i; t += 2) {
          (0, y[t])(y[t + 1]), y[t] = void 0, y[t + 1] = void 0;
        }

        i = 0;
      }

      var b,
          v,
          _,
          g,
          w = void 0;

      function T(t, e) {
        var r = arguments,
            n = this,
            o = new this.constructor(S);
        void 0 === o[O] && q(o);
        var i,
            s = n._state;
        return s ? (i = r[s - 1], u(function () {
          return H(s, o, i, n._result);
        })) : D(n, o, t, e), o;
      }

      function E(t) {
        if (t && "object" == typeof t && t.constructor === this) return t;
        var e = new this(S);
        return x(e, t), e;
      }

      p ? w = function w() {
        return e.nextTick(m);
      } : f ? (v = 0, _ = new f(m), g = document.createTextNode(""), _.observe(g, {
        characterData: !0
      }), w = function w() {
        g.data = v = ++v % 2;
      }) : h ? ((b = new MessageChannel()).port1.onmessage = m, w = function w() {
        return b.port2.postMessage(0);
      }) : w = void 0 === c ? function () {
        try {
          var t = r(14);
          return s = t.runOnLoop || t.runOnContext, function () {
            s(m);
          };
        } catch (t) {
          return d();
        }
      }() : d();
      var O = Math.random().toString(36).substring(16);

      function S() {}

      var j = void 0,
          A = new U();

      function N(t) {
        try {
          return t.then;
        } catch (t) {
          return A.error = t, A;
        }
      }

      function R(e, r, n) {
        r.constructor === e.constructor && n === T && r.constructor.resolve === E ? function (t, e) {
          1 === e._state ? k(t, e._result) : 2 === e._state ? C(t, e._result) : D(e, void 0, function (e) {
            return x(t, e);
          }, function (e) {
            return C(t, e);
          });
        }(e, r) : n === A ? C(e, A.error) : void 0 === n ? k(e, r) : t(n) ? function (t, e, r) {
          u(function (t) {
            var n = !1,
                o = function (t, e, r, n) {
              try {
                t.call(e, r, n);
              } catch (t) {
                return t;
              }
            }(r, e, function (r) {
              n || (n = !0, e !== r ? x(t, r) : k(t, r));
            }, function (e) {
              n || (n = !0, C(t, e));
            }, t._label);

            !n && o && (n = !0, C(t, o));
          }, t);
        }(e, r, n) : k(e, r);
      }

      function x(t, e) {
        var r;
        t === e ? C(t, new TypeError("You cannot resolve a promise with itself")) : "function" == typeof (r = e) || "object" == typeof r && null !== r ? R(t, e, N(e)) : k(t, e);
      }

      function P(t) {
        t._onerror && t._onerror(t._result), L(t);
      }

      function k(t, e) {
        t._state === j && (t._result = e, t._state = 1, 0 !== t._subscribers.length && u(L, t));
      }

      function C(t, e) {
        t._state === j && (t._state = 2, t._result = e, u(P, t));
      }

      function D(t, e, r, n) {
        var o = t._subscribers,
            i = o.length;
        t._onerror = null, o[i] = e, o[i + 1] = r, o[i + 2] = n, 0 === i && t._state && u(L, t);
      }

      function L(t) {
        var e = t._subscribers,
            r = t._state;

        if (0 !== e.length) {
          for (var n = void 0, o = void 0, i = t._result, s = 0; s < e.length; s += 3) {
            n = e[s], o = e[s + r], n ? H(r, n, o, i) : o(i);
          }

          t._subscribers.length = 0;
        }
      }

      function U() {
        this.error = null;
      }

      var I = new U();

      function H(e, r, n, o) {
        var i = t(n),
            s = void 0,
            a = void 0,
            u = void 0,
            c = void 0;

        if (i) {
          if ((s = function (t, e) {
            try {
              return t(e);
            } catch (t) {
              return I.error = t, I;
            }
          }(n, o)) === I ? (c = !0, a = s.error, s = null) : u = !0, r === s) return void C(r, new TypeError("A promises callback cannot return that same promise."));
        } else s = o, u = !0;

        r._state !== j || (i && u ? x(r, s) : c ? C(r, a) : 1 === e ? k(r, s) : 2 === e && C(r, s));
      }

      var M = 0;

      function q(t) {
        t[O] = M++, t._state = void 0, t._result = void 0, t._subscribers = [];
      }

      function F(t, e) {
        this._instanceConstructor = t, this.promise = new t(S), this.promise[O] || q(this.promise), o(e) ? (this._input = e, this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? k(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(), 0 === this._remaining && k(this.promise, this._result))) : C(this.promise, new Error("Array Methods must be provided an Array"));
      }

      function K(t) {
        this[O] = M++, this._result = this._state = void 0, this._subscribers = [], S !== t && ("function" != typeof t && function () {
          throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
        }(), this instanceof K ? function (t, e) {
          try {
            e(function (e) {
              x(t, e);
            }, function (e) {
              C(t, e);
            });
          } catch (e) {
            C(t, e);
          }
        }(this, t) : function () {
          throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        }());
      }

      function z() {
        var t = void 0;
        if (void 0 !== n) t = n;else if ("undefined" != typeof self) t = self;else try {
          t = Function("return this")();
        } catch (t) {
          throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var e = t.Promise;

        if (e) {
          var r = null;

          try {
            r = Object.prototype.toString.call(e.resolve());
          } catch (t) {}

          if ("[object Promise]" === r && !e.cast) return;
        }

        t.Promise = K;
      }

      return F.prototype._enumerate = function () {
        for (var t = this.length, e = this._input, r = 0; this._state === j && r < t; r++) {
          this._eachEntry(e[r], r);
        }
      }, F.prototype._eachEntry = function (t, e) {
        var r = this._instanceConstructor,
            n = r.resolve;

        if (n === E) {
          var o = N(t);
          if (o === T && t._state !== j) this._settledAt(t._state, e, t._result);else if ("function" != typeof o) this._remaining--, this._result[e] = t;else if (r === K) {
            var i = new r(S);
            R(i, t, o), this._willSettleAt(i, e);
          } else this._willSettleAt(new r(function (e) {
            return e(t);
          }), e);
        } else this._willSettleAt(n(t), e);
      }, F.prototype._settledAt = function (t, e, r) {
        var n = this.promise;
        n._state === j && (this._remaining--, 2 === t ? C(n, r) : this._result[e] = r), 0 === this._remaining && k(n, this._result);
      }, F.prototype._willSettleAt = function (t, e) {
        var r = this;
        D(t, void 0, function (t) {
          return r._settledAt(1, e, t);
        }, function (t) {
          return r._settledAt(2, e, t);
        });
      }, K.all = function (t) {
        return new F(this, t).promise;
      }, K.race = function (t) {
        var e = this;
        return o(t) ? new e(function (r, n) {
          for (var o = t.length, i = 0; i < o; i++) {
            e.resolve(t[i]).then(r, n);
          }
        }) : new e(function (t, e) {
          return e(new TypeError("You must pass an array to race."));
        });
      }, K.resolve = E, K.reject = function (t) {
        var e = new this(S);
        return C(e, t), e;
      }, K._setScheduler = function (t) {
        a = t;
      }, K._setAsap = function (t) {
        u = t;
      }, K._asap = u, K.prototype = {
        constructor: K,
        then: T,
        catch: function _catch(t) {
          return this.then(null, t);
        }
      }, z(), K.polyfill = z, K.Promise = K, K;
    }, t.exports = o();
  }).call(this, r(12), r(13));
}, function (t, e) {
  var r,
      n,
      o = t.exports = {};

  function i() {
    throw new Error("setTimeout has not been defined");
  }

  function s() {
    throw new Error("clearTimeout has not been defined");
  }

  function a(t) {
    if (r === setTimeout) return setTimeout(t, 0);
    if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

    try {
      return r(t, 0);
    } catch (e) {
      try {
        return r.call(null, t, 0);
      } catch (e) {
        return r.call(this, t, 0);
      }
    }
  }

  !function () {
    try {
      r = "function" == typeof setTimeout ? setTimeout : i;
    } catch (t) {
      r = i;
    }

    try {
      n = "function" == typeof clearTimeout ? clearTimeout : s;
    } catch (t) {
      n = s;
    }
  }();
  var u,
      c = [],
      l = !1,
      f = -1;

  function p() {
    l && u && (l = !1, u.length ? c = u.concat(c) : f = -1, c.length && h());
  }

  function h() {
    if (!l) {
      var t = a(p);
      l = !0;

      for (var e = c.length; e;) {
        for (u = c, c = []; ++f < e;) {
          u && u[f].run();
        }

        f = -1, e = c.length;
      }

      u = null, l = !1, function (t) {
        if (n === clearTimeout) return clearTimeout(t);
        if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

        try {
          n(t);
        } catch (e) {
          try {
            return n.call(null, t);
          } catch (e) {
            return n.call(this, t);
          }
        }
      }(t);
    }
  }

  function d(t, e) {
    this.fun = t, this.array = e;
  }

  function y() {}

  o.nextTick = function (t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
      e[r - 1] = arguments[r];
    }
    c.push(new d(t, e)), 1 !== c.length || l || a(h);
  }, d.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function (t) {
    return [];
  }, o.binding = function (t) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (t) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (t, e) {
  var r;

  r = function () {
    return this;
  }();

  try {
    r = r || new Function("return this")();
  } catch (t) {
    "object" == typeof window && (r = window);
  }

  t.exports = r;
}, function (t, e) {}, function (t, e, r) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.FILESTORE_URL = e.URL = void 0, e.URL = "https://tripetto.app", e.FILESTORE_URL = "https://filestore.tripetto.app";
}, function (t, e, r) {
  "use strict";

  (function (t) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getL10n = e.getStyles = e.getDefinition = void 0;

    var n = r(1).__importStar(r(2)),
        o = r(9),
        i = r(4),
        s = r(3);

    e.getDefinition = function (e, r) {
      return new t(function (t) {
        n.get(o.noCacheUrl(e + s.DEFINITION, r)).set(i.HEADER_RUNNER_TOKEN, r).set("Cache-Control", "no-store").then(function (e) {
          var r;
          return t(null === (r = e.body) || void 0 === r ? void 0 : r.definition);
        }).catch(function () {
          return t(void 0);
        });
      });
    }, e.getStyles = function (e, r) {
      return new t(function (t) {
        n.get(o.noCacheUrl(e + s.STYLES, r)).set(i.HEADER_RUNNER_TOKEN, r).set("Cache-Control", "no-store").then(function (e) {
          var r;
          return t(null === (r = e.body) || void 0 === r ? void 0 : r.styles);
        }).catch(function () {
          return t(void 0);
        });
      });
    }, e.getL10n = function (e, r) {
      return new t(function (t) {
        n.get(o.noCacheUrl(e + s.L10N, r)).set(i.HEADER_RUNNER_TOKEN, r).set("Cache-Control", "no-store").then(function (e) {
          var r;
          return t(null === (r = e.body) || void 0 === r ? void 0 : r.l10n);
        }).catch(function () {
          return t(void 0);
        });
      });
    };
  }).call(this, r(0));
}, function (t, e, r) {
  function n(t) {
    if (t) return function (t) {
      for (var e in n.prototype) {
        t[e] = n.prototype[e];
      }

      return t;
    }(t);
  }

  t.exports = n, n.prototype.on = n.prototype.addEventListener = function (t, e) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
  }, n.prototype.once = function (t, e) {
    function r() {
      this.off(t, r), e.apply(this, arguments);
    }

    return r.fn = e, this.on(t, r), this;
  }, n.prototype.off = n.prototype.removeListener = n.prototype.removeAllListeners = n.prototype.removeEventListener = function (t, e) {
    if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
    var r,
        n = this._callbacks["$" + t];
    if (!n) return this;
    if (1 == arguments.length) return delete this._callbacks["$" + t], this;

    for (var o = 0; o < n.length; o++) {
      if ((r = n[o]) === e || r.fn === e) {
        n.splice(o, 1);
        break;
      }
    }

    return 0 === n.length && delete this._callbacks["$" + t], this;
  }, n.prototype.emit = function (t) {
    this._callbacks = this._callbacks || {};

    for (var e = new Array(arguments.length - 1), r = this._callbacks["$" + t], n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }

    if (r) {
      n = 0;

      for (var o = (r = r.slice(0)).length; n < o; ++n) {
        r[n].apply(this, e);
      }
    }

    return this;
  }, n.prototype.listeners = function (t) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
  }, n.prototype.hasListeners = function (t) {
    return !!this.listeners(t).length;
  };
}, function (t, e) {
  t.exports = o, o.default = o, o.stable = a, o.stableStringify = a;
  var r = [],
      n = [];

  function o(t, e, o) {
    var s;

    for (i(t, "", [], void 0), s = 0 === n.length ? JSON.stringify(t, e, o) : JSON.stringify(t, c(e), o); 0 !== r.length;) {
      var a = r.pop();
      4 === a.length ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
    }

    return s;
  }

  function i(t, e, o, s) {
    var a;

    if ("object" == typeof t && null !== t) {
      for (a = 0; a < o.length; a++) {
        if (o[a] === t) {
          var u = Object.getOwnPropertyDescriptor(s, e);
          return void (void 0 !== u.get ? u.configurable ? (Object.defineProperty(s, e, {
            value: "[Circular]"
          }), r.push([s, e, t, u])) : n.push([t, e]) : (s[e] = "[Circular]", r.push([s, e, t])));
        }
      }

      if (o.push(t), Array.isArray(t)) for (a = 0; a < t.length; a++) {
        i(t[a], a, o, t);
      } else {
        var c = Object.keys(t);

        for (a = 0; a < c.length; a++) {
          var l = c[a];
          i(t[l], l, o, t);
        }
      }
      o.pop();
    }
  }

  function s(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
  }

  function a(t, e, o) {
    var i,
        s = u(t, "", [], void 0) || t;

    for (i = 0 === n.length ? JSON.stringify(s, e, o) : JSON.stringify(s, c(e), o); 0 !== r.length;) {
      var a = r.pop();
      4 === a.length ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
    }

    return i;
  }

  function u(t, e, o, i) {
    var a;

    if ("object" == typeof t && null !== t) {
      for (a = 0; a < o.length; a++) {
        if (o[a] === t) {
          var c = Object.getOwnPropertyDescriptor(i, e);
          return void (void 0 !== c.get ? c.configurable ? (Object.defineProperty(i, e, {
            value: "[Circular]"
          }), r.push([i, e, t, c])) : n.push([t, e]) : (i[e] = "[Circular]", r.push([i, e, t])));
        }
      }

      if ("function" == typeof t.toJSON) return;
      if (o.push(t), Array.isArray(t)) for (a = 0; a < t.length; a++) {
        u(t[a], a, o, t);
      } else {
        var l = {},
            f = Object.keys(t).sort(s);

        for (a = 0; a < f.length; a++) {
          var p = f[a];
          u(t[p], p, o, t), l[p] = t[p];
        }

        if (void 0 === i) return l;
        r.push([i, e, t]), i[e] = l;
      }
      o.pop();
    }
  }

  function c(t) {
    return t = void 0 !== t ? t : function (t, e) {
      return e;
    }, function (e, r) {
      if (n.length > 0) for (var o = 0; o < n.length; o++) {
        var i = n[o];

        if (i[1] === e && i[0] === r) {
          r = "[Circular]", n.splice(o, 1);
          break;
        }
      }
      return t.call(this, e, r);
    };
  }
}, function (t, e, r) {
  "use strict";

  var n = r(20),
      o = r(21),
      i = r(7);
  t.exports = {
    formats: i,
    parse: o,
    stringify: n
  };
}, function (t, e, r) {
  "use strict";

  var n = r(6),
      o = r(7),
      i = Object.prototype.hasOwnProperty,
      s = {
    brackets: function brackets(t) {
      return t + "[]";
    },
    comma: "comma",
    indices: function indices(t, e) {
      return t + "[" + e + "]";
    },
    repeat: function repeat(t) {
      return t;
    }
  },
      a = Array.isArray,
      u = Array.prototype.push,
      c = function c(t, e) {
    u.apply(t, a(e) ? e : [e]);
  },
      l = Date.prototype.toISOString,
      f = o.default,
      p = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: n.encode,
    encodeValuesOnly: !1,
    format: f,
    formatter: o.formatters[f],
    indices: !1,
    serializeDate: function serializeDate(t) {
      return l.call(t);
    },
    skipNulls: !1,
    strictNullHandling: !1
  },
      h = function t(e, r, o, i, s, u, l, f, h, d, y, m, b) {
    var v,
        _ = e;

    if ("function" == typeof l ? _ = l(r, _) : _ instanceof Date ? _ = d(_) : "comma" === o && a(_) && (_ = n.maybeMap(_, function (t) {
      return t instanceof Date ? d(t) : t;
    }).join(",")), null === _) {
      if (i) return u && !m ? u(r, p.encoder, b, "key") : r;
      _ = "";
    }

    if ("string" == typeof (v = _) || "number" == typeof v || "boolean" == typeof v || "symbol" == typeof v || "bigint" == typeof v || n.isBuffer(_)) return u ? [y(m ? r : u(r, p.encoder, b, "key")) + "=" + y(u(_, p.encoder, b, "value"))] : [y(r) + "=" + y(String(_))];
    var g,
        w = [];
    if (void 0 === _) return w;
    if (a(l)) g = l;else {
      var T = Object.keys(_);
      g = f ? T.sort(f) : T;
    }

    for (var E = 0; E < g.length; ++E) {
      var O = g[E],
          S = _[O];

      if (!s || null !== S) {
        var j = a(_) ? "function" == typeof o ? o(r, O) : r : r + (h ? "." + O : "[" + O + "]");
        c(w, t(S, j, o, i, s, u, l, f, h, d, y, m, b));
      }
    }

    return w;
  };

  t.exports = function (t, e) {
    var r,
        n = t,
        u = function (t) {
      if (!t) return p;
      if (null !== t.encoder && void 0 !== t.encoder && "function" != typeof t.encoder) throw new TypeError("Encoder has to be a function.");
      var e = t.charset || p.charset;
      if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      var r = o.default;

      if (void 0 !== t.format) {
        if (!i.call(o.formatters, t.format)) throw new TypeError("Unknown format option provided.");
        r = t.format;
      }

      var n = o.formatters[r],
          s = p.filter;
      return ("function" == typeof t.filter || a(t.filter)) && (s = t.filter), {
        addQueryPrefix: "boolean" == typeof t.addQueryPrefix ? t.addQueryPrefix : p.addQueryPrefix,
        allowDots: void 0 === t.allowDots ? p.allowDots : !!t.allowDots,
        charset: e,
        charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : p.charsetSentinel,
        delimiter: void 0 === t.delimiter ? p.delimiter : t.delimiter,
        encode: "boolean" == typeof t.encode ? t.encode : p.encode,
        encoder: "function" == typeof t.encoder ? t.encoder : p.encoder,
        encodeValuesOnly: "boolean" == typeof t.encodeValuesOnly ? t.encodeValuesOnly : p.encodeValuesOnly,
        filter: s,
        formatter: n,
        serializeDate: "function" == typeof t.serializeDate ? t.serializeDate : p.serializeDate,
        skipNulls: "boolean" == typeof t.skipNulls ? t.skipNulls : p.skipNulls,
        sort: "function" == typeof t.sort ? t.sort : null,
        strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : p.strictNullHandling
      };
    }(e);

    "function" == typeof u.filter ? n = (0, u.filter)("", n) : a(u.filter) && (r = u.filter);
    var l,
        f = [];
    if ("object" != typeof n || null === n) return "";
    l = e && e.arrayFormat in s ? e.arrayFormat : e && "indices" in e ? e.indices ? "indices" : "repeat" : "indices";
    var d = s[l];
    r || (r = Object.keys(n)), u.sort && r.sort(u.sort);

    for (var y = 0; y < r.length; ++y) {
      var m = r[y];
      u.skipNulls && null === n[m] || c(f, h(n[m], m, d, u.strictNullHandling, u.skipNulls, u.encode ? u.encoder : null, u.filter, u.sort, u.allowDots, u.serializeDate, u.formatter, u.encodeValuesOnly, u.charset));
    }

    var b = f.join(u.delimiter),
        v = !0 === u.addQueryPrefix ? "?" : "";
    return u.charsetSentinel && ("iso-8859-1" === u.charset ? v += "utf8=%26%2310003%3B&" : v += "utf8=%E2%9C%93&"), b.length > 0 ? v + b : "";
  };
}, function (t, e, r) {
  "use strict";

  var n = r(6),
      o = Object.prototype.hasOwnProperty,
      i = Array.isArray,
      s = {
    allowDots: !1,
    allowPrototypes: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: n.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  },
      a = function a(t) {
    return t.replace(/&#(\d+);/g, function (t, e) {
      return String.fromCharCode(parseInt(e, 10));
    });
  },
      u = function u(t, e) {
    return t && "string" == typeof t && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
  },
      c = function c(t, e, r, n) {
    if (t) {
      var i = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t,
          s = /(\[[^[\]]*])/g,
          a = r.depth > 0 && /(\[[^[\]]*])/.exec(i),
          c = a ? i.slice(0, a.index) : i,
          l = [];

      if (c) {
        if (!r.plainObjects && o.call(Object.prototype, c) && !r.allowPrototypes) return;
        l.push(c);
      }

      for (var f = 0; r.depth > 0 && null !== (a = s.exec(i)) && f < r.depth;) {
        if (f += 1, !r.plainObjects && o.call(Object.prototype, a[1].slice(1, -1)) && !r.allowPrototypes) return;
        l.push(a[1]);
      }

      return a && l.push("[" + i.slice(a.index) + "]"), function (t, e, r, n) {
        for (var o = n ? e : u(e, r), i = t.length - 1; i >= 0; --i) {
          var s,
              a = t[i];
          if ("[]" === a && r.parseArrays) s = [].concat(o);else {
            s = r.plainObjects ? Object.create(null) : {};
            var c = "[" === a.charAt(0) && "]" === a.charAt(a.length - 1) ? a.slice(1, -1) : a,
                l = parseInt(c, 10);
            r.parseArrays || "" !== c ? !isNaN(l) && a !== c && String(l) === c && l >= 0 && r.parseArrays && l <= r.arrayLimit ? (s = [])[l] = o : s[c] = o : s = {
              0: o
            };
          }
          o = s;
        }

        return o;
      }(l, e, r, n);
    }
  };

  t.exports = function (t, e) {
    var r = function (t) {
      if (!t) return s;
      if (null !== t.decoder && void 0 !== t.decoder && "function" != typeof t.decoder) throw new TypeError("Decoder has to be a function.");
      if (void 0 !== t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      var e = void 0 === t.charset ? s.charset : t.charset;
      return {
        allowDots: void 0 === t.allowDots ? s.allowDots : !!t.allowDots,
        allowPrototypes: "boolean" == typeof t.allowPrototypes ? t.allowPrototypes : s.allowPrototypes,
        arrayLimit: "number" == typeof t.arrayLimit ? t.arrayLimit : s.arrayLimit,
        charset: e,
        charsetSentinel: "boolean" == typeof t.charsetSentinel ? t.charsetSentinel : s.charsetSentinel,
        comma: "boolean" == typeof t.comma ? t.comma : s.comma,
        decoder: "function" == typeof t.decoder ? t.decoder : s.decoder,
        delimiter: "string" == typeof t.delimiter || n.isRegExp(t.delimiter) ? t.delimiter : s.delimiter,
        depth: "number" == typeof t.depth || !1 === t.depth ? +t.depth : s.depth,
        ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
        interpretNumericEntities: "boolean" == typeof t.interpretNumericEntities ? t.interpretNumericEntities : s.interpretNumericEntities,
        parameterLimit: "number" == typeof t.parameterLimit ? t.parameterLimit : s.parameterLimit,
        parseArrays: !1 !== t.parseArrays,
        plainObjects: "boolean" == typeof t.plainObjects ? t.plainObjects : s.plainObjects,
        strictNullHandling: "boolean" == typeof t.strictNullHandling ? t.strictNullHandling : s.strictNullHandling
      };
    }(e);

    if ("" === t || null == t) return r.plainObjects ? Object.create(null) : {};

    for (var l = "string" == typeof t ? function (t, e) {
      var r,
          c = {},
          l = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t,
          f = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit,
          p = l.split(e.delimiter, f),
          h = -1,
          d = e.charset;
      if (e.charsetSentinel) for (r = 0; r < p.length; ++r) {
        0 === p[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === p[r] ? d = "utf-8" : "utf8=%26%2310003%3B" === p[r] && (d = "iso-8859-1"), h = r, r = p.length);
      }

      for (r = 0; r < p.length; ++r) {
        if (r !== h) {
          var y,
              m,
              b = p[r],
              v = b.indexOf("]="),
              _ = -1 === v ? b.indexOf("=") : v + 1;

          -1 === _ ? (y = e.decoder(b, s.decoder, d, "key"), m = e.strictNullHandling ? null : "") : (y = e.decoder(b.slice(0, _), s.decoder, d, "key"), m = n.maybeMap(u(b.slice(_ + 1), e), function (t) {
            return e.decoder(t, s.decoder, d, "value");
          })), m && e.interpretNumericEntities && "iso-8859-1" === d && (m = a(m)), b.indexOf("[]=") > -1 && (m = i(m) ? [m] : m), o.call(c, y) ? c[y] = n.combine(c[y], m) : c[y] = m;
        }
      }

      return c;
    }(t, r) : t, f = r.plainObjects ? Object.create(null) : {}, p = Object.keys(l), h = 0; h < p.length; ++h) {
      var d = p[h],
          y = c(d, l[d], r, "string" == typeof t);
      f = n.merge(f, y, r);
    }

    return n.compact(f);
  };
}, function (t, e, r) {
  "use strict";

  (function (e) {
    function n(t) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    var o = r(8);

    function i(t) {
      if (t) return function (t) {
        for (var e in i.prototype) {
          Object.prototype.hasOwnProperty.call(i.prototype, e) && (t[e] = i.prototype[e]);
        }

        return t;
      }(t);
    }

    t.exports = i, i.prototype.clearTimeout = function () {
      return clearTimeout(this._timer), clearTimeout(this._responseTimeoutTimer), clearTimeout(this._uploadTimeoutTimer), delete this._timer, delete this._responseTimeoutTimer, delete this._uploadTimeoutTimer, this;
    }, i.prototype.parse = function (t) {
      return this._parser = t, this;
    }, i.prototype.responseType = function (t) {
      return this._responseType = t, this;
    }, i.prototype.serialize = function (t) {
      return this._serializer = t, this;
    }, i.prototype.timeout = function (t) {
      if (!t || "object" !== n(t)) return this._timeout = t, this._responseTimeout = 0, this._uploadTimeout = 0, this;

      for (var e in t) {
        if (Object.prototype.hasOwnProperty.call(t, e)) switch (e) {
          case "deadline":
            this._timeout = t.deadline;
            break;

          case "response":
            this._responseTimeout = t.response;
            break;

          case "upload":
            this._uploadTimeout = t.upload;
            break;

          default:
            console.warn("Unknown timeout option", e);
        }
      }

      return this;
    }, i.prototype.retry = function (t, e) {
      return 0 !== arguments.length && !0 !== t || (t = 1), t <= 0 && (t = 0), this._maxRetries = t, this._retries = 0, this._retryCallback = e, this;
    };
    var s = new Set(["ETIMEDOUT", "ECONNRESET", "EADDRINUSE", "ECONNREFUSED", "EPIPE", "ENOTFOUND", "ENETUNREACH", "EAI_AGAIN"]),
        a = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524]);
    i.prototype._shouldRetry = function (t, e) {
      if (!this._maxRetries || this._retries++ >= this._maxRetries) return !1;
      if (this._retryCallback) try {
        var r = this._retryCallback(t, e);

        if (!0 === r) return !0;
        if (!1 === r) return !1;
      } catch (t) {
        console.error(t);
      }
      if (e && e.status && a.has(e.status)) return !0;

      if (t) {
        if (t.code && s.has(t.code)) return !0;
        if (t.timeout && "ECONNABORTED" === t.code) return !0;
        if (t.crossDomain) return !0;
      }

      return !1;
    }, i.prototype._retry = function () {
      return this.clearTimeout(), this.req && (this.req = null, this.req = this.request()), this._aborted = !1, this.timedout = !1, this.timedoutError = null, this._end();
    }, i.prototype.then = function (t, r) {
      var n = this;

      if (!this._fullfilledPromise) {
        var o = this;
        this._endCalled && console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"), this._fullfilledPromise = new e(function (t, e) {
          o.on("abort", function () {
            if (!(n._maxRetries && n._maxRetries > n._retries)) if (n.timedout && n.timedoutError) e(n.timedoutError);else {
              var t = new Error("Aborted");
              t.code = "ABORTED", t.status = n.status, t.method = n.method, t.url = n.url, e(t);
            }
          }), o.end(function (r, n) {
            r ? e(r) : t(n);
          });
        });
      }

      return this._fullfilledPromise.then(t, r);
    }, i.prototype.catch = function (t) {
      return this.then(void 0, t);
    }, i.prototype.use = function (t) {
      return t(this), this;
    }, i.prototype.ok = function (t) {
      if ("function" != typeof t) throw new Error("Callback required");
      return this._okCallback = t, this;
    }, i.prototype._isResponseOK = function (t) {
      return !!t && (this._okCallback ? this._okCallback(t) : t.status >= 200 && t.status < 300);
    }, i.prototype.get = function (t) {
      return this._header[t.toLowerCase()];
    }, i.prototype.getHeader = i.prototype.get, i.prototype.set = function (t, e) {
      if (o(t)) {
        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && this.set(r, t[r]);
        }

        return this;
      }

      return this._header[t.toLowerCase()] = e, this.header[t] = e, this;
    }, i.prototype.unset = function (t) {
      return delete this._header[t.toLowerCase()], delete this.header[t], this;
    }, i.prototype.field = function (t, e) {
      if (null == t) throw new Error(".field(name, val) name can not be empty");
      if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");

      if (o(t)) {
        for (var r in t) {
          Object.prototype.hasOwnProperty.call(t, r) && this.field(r, t[r]);
        }

        return this;
      }

      if (Array.isArray(e)) {
        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && this.field(t, e[n]);
        }

        return this;
      }

      if (null == e) throw new Error(".field(name, val) val can not be empty");
      return "boolean" == typeof e && (e = String(e)), this._getFormData().append(t, e), this;
    }, i.prototype.abort = function () {
      return this._aborted || (this._aborted = !0, this.xhr && this.xhr.abort(), this.req && this.req.abort(), this.clearTimeout(), this.emit("abort")), this;
    }, i.prototype._auth = function (t, e, r, n) {
      switch (r.type) {
        case "basic":
          this.set("Authorization", "Basic ".concat(n("".concat(t, ":").concat(e))));
          break;

        case "auto":
          this.username = t, this.password = e;
          break;

        case "bearer":
          this.set("Authorization", "Bearer ".concat(t));
      }

      return this;
    }, i.prototype.withCredentials = function (t) {
      return void 0 === t && (t = !0), this._withCredentials = t, this;
    }, i.prototype.redirects = function (t) {
      return this._maxRedirects = t, this;
    }, i.prototype.maxResponseSize = function (t) {
      if ("number" != typeof t) throw new TypeError("Invalid argument");
      return this._maxResponseSize = t, this;
    }, i.prototype.toJSON = function () {
      return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
      };
    }, i.prototype.send = function (t) {
      var e = o(t),
          r = this._header["content-type"];
      if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
      if (e && !this._data) Array.isArray(t) ? this._data = [] : this._isHost(t) || (this._data = {});else if (t && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
      if (e && o(this._data)) for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (this._data[n] = t[n]);
      } else "string" == typeof t ? (r || this.type("form"), (r = this._header["content-type"]) && (r = r.toLowerCase().trim()), this._data = "application/x-www-form-urlencoded" === r ? this._data ? "".concat(this._data, "&").concat(t) : t : (this._data || "") + t) : this._data = t;
      return !e || this._isHost(t) || r || this.type("json"), this;
    }, i.prototype.sortQuery = function (t) {
      return this._sort = void 0 === t || t, this;
    }, i.prototype._finalizeQueryString = function () {
      var t = this._query.join("&");

      if (t && (this.url += (this.url.includes("?") ? "&" : "?") + t), this._query.length = 0, this._sort) {
        var e = this.url.indexOf("?");

        if (e >= 0) {
          var r = this.url.slice(e + 1).split("&");
          "function" == typeof this._sort ? r.sort(this._sort) : r.sort(), this.url = this.url.slice(0, e) + "?" + r.join("&");
        }
      }
    }, i.prototype._appendQueryString = function () {
      console.warn("Unsupported");
    }, i.prototype._timeoutError = function (t, e, r) {
      if (!this._aborted) {
        var n = new Error("".concat(t + e, "ms exceeded"));
        n.timeout = e, n.code = "ECONNABORTED", n.errno = r, this.timedout = !0, this.timedoutError = n, this.abort(), this.callback(n);
      }
    }, i.prototype._setTimeouts = function () {
      var t = this;
      this._timeout && !this._timer && (this._timer = setTimeout(function () {
        t._timeoutError("Timeout of ", t._timeout, "ETIME");
      }, this._timeout)), this._responseTimeout && !this._responseTimeoutTimer && (this._responseTimeoutTimer = setTimeout(function () {
        t._timeoutError("Response timeout of ", t._responseTimeout, "ETIMEDOUT");
      }, this._responseTimeout));
    };
  }).call(this, r(0));
}, function (t, e, r) {
  "use strict";

  var n = r(24);

  function o(t) {
    if (t) return function (t) {
      for (var e in o.prototype) {
        Object.prototype.hasOwnProperty.call(o.prototype, e) && (t[e] = o.prototype[e]);
      }

      return t;
    }(t);
  }

  t.exports = o, o.prototype.get = function (t) {
    return this.header[t.toLowerCase()];
  }, o.prototype._setHeaderProperties = function (t) {
    var e = t["content-type"] || "";
    this.type = n.type(e);
    var r = n.params(e);

    for (var o in r) {
      Object.prototype.hasOwnProperty.call(r, o) && (this[o] = r[o]);
    }

    this.links = {};

    try {
      t.link && (this.links = n.parseLinks(t.link));
    } catch (t) {}
  }, o.prototype._setStatusProperties = function (t) {
    var e = t / 100 | 0;
    this.statusCode = t, this.status = this.statusCode, this.statusType = e, this.info = 1 === e, this.ok = 2 === e, this.redirect = 3 === e, this.clientError = 4 === e, this.serverError = 5 === e, this.error = (4 === e || 5 === e) && this.toError(), this.created = 201 === t, this.accepted = 202 === t, this.noContent = 204 === t, this.badRequest = 400 === t, this.unauthorized = 401 === t, this.notAcceptable = 406 === t, this.forbidden = 403 === t, this.notFound = 404 === t, this.unprocessableEntity = 422 === t;
  };
}, function (t, e, r) {
  "use strict";

  function n(t, e) {
    var r;

    if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
      if (Array.isArray(t) || (r = function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return o(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);

        var _n2 = 0,
            i = function i() {};

        return {
          s: i,
          n: function n() {
            return _n2 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n2++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: i
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var s,
        a = !0,
        u = !1;
    return {
      s: function s() {
        r = t[Symbol.iterator]();
      },
      n: function n() {
        var t = r.next();
        return a = t.done, t;
      },
      e: function e(t) {
        u = !0, s = t;
      },
      f: function f() {
        try {
          a || null == r.return || r.return();
        } finally {
          if (u) throw s;
        }
      }
    };
  }

  function o(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }

    return n;
  }

  e.type = function (t) {
    return t.split(/ *; */).shift();
  }, e.params = function (t) {
    var e,
        r = {},
        o = n(t.split(/ *; */));

    try {
      for (o.s(); !(e = o.n()).done;) {
        var i = e.value.split(/ *= */),
            s = i.shift(),
            a = i.shift();
        s && a && (r[s] = a);
      }
    } catch (t) {
      o.e(t);
    } finally {
      o.f();
    }

    return r;
  }, e.parseLinks = function (t) {
    var e,
        r = {},
        o = n(t.split(/ *, */));

    try {
      for (o.s(); !(e = o.n()).done;) {
        var i = e.value.split(/ *; */),
            s = i[0].slice(1, -1);
        r[i[1].split(/ *= */)[1].slice(1, -1)] = s;
      }
    } catch (t) {
      o.e(t);
    } finally {
      o.f();
    }

    return r;
  }, e.cleanHeader = function (t, e) {
    return delete t["content-type"], delete t["content-length"], delete t["transfer-encoding"], delete t.host, e && (delete t.authorization, delete t.cookie), t;
  };
}, function (t, e, r) {
  "use strict";

  function n(t) {
    return function (t) {
      if (Array.isArray(t)) return o(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return o(t, e);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === r && t.constructor && (r = t.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(t);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o(t, e);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function o(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }

    return n;
  }

  function i() {
    this._defaults = [];
  }

  ["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert", "disableTLSCerts"].forEach(function (t) {
    i.prototype[t] = function () {
      for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
        r[n] = arguments[n];
      }

      return this._defaults.push({
        fn: t,
        args: r
      }), this;
    };
  }), i.prototype._setDefaults = function (t) {
    this._defaults.forEach(function (e) {
      t[e.fn].apply(t, n(e.args));
    });
  }, t.exports = i;
}, function (t, e, r) {
  "use strict";

  (function (t) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.saveSnapshot = e.getSnapshot = void 0;

    var n = r(1).__importStar(r(2)),
        o = r(4),
        i = r(3),
        s = r(9);

    e.getSnapshot = function (e, r) {
      return new t(function (t) {
        n.get(s.noCacheUrl(e + i.SNAPSHOT, r)).set(o.HEADER_RUNNER_TOKEN, r).set("Cache-Control", "no-store").then(function (e) {
          return t(200 === e.status && e.body || void 0);
        }).catch(function () {
          return t(void 0);
        });
      });
    }, e.saveSnapshot = function (e, r, s, a, u, c, l) {
      return new t(function (f, p) {
        n.post(e + i.SNAPSHOT).set(o.HEADER_RUNNER_TOKEN, r).send({
          emailAddress: a,
          snapshot: s,
          language: u,
          locale: c,
          runner: l
        }).then(function (t) {
          200 === t.status ? f() : p(t.error && t.error.text || void 0);
        }).catch(function () {
          return t.reject();
        });
      });
    };
  }).call(this, r(0));
}, function (t, e, r) {
  "use strict";

  (function (t) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getLocale = void 0;

    var n = r(1).__importStar(r(2)),
        o = r(3),
        i = {};

    e.getLocale = function (e, r) {
      return new t(function (t) {
        var s = e + o.LOCALE + (r && "auto" !== r ? "?l=" + encodeURIComponent(r) : ""),
            a = i[s];
        a ? t(a) : n.get(s).send().then(function (e) {
          return t(i[s] = e.body);
        }).catch(function () {
          return t(void 0);
        });
      });
    };
  }).call(this, r(0));
}, function (t, e, r) {
  "use strict";

  (function (t) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getTranslation = void 0;

    var n = r(1).__importStar(r(2)),
        o = r(3),
        i = {};

    e.getTranslation = function (e, r, s) {
      return new t(function (t) {
        var a = "";
        r && "auto" !== r && (a += ("" === a ? "?" : "&") + "l=" + encodeURIComponent(r)), s && (a += ("" === a ? "?" : "&") + "c=" + encodeURIComponent(s));
        var u = e + o.TRANSLATION + a,
            c = i[u];
        c ? t(c) : n.get(e + o.TRANSLATION + a).send().then(function (e) {
          return t(i[u] = e.body);
        }).catch(function () {
          return t(void 0);
        });
      });
    };
  }).call(this, r(0));
}, function (t, e, r) {
  "use strict";

  (function (t) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.submitResponse = void 0;

    var n = r(1).__importStar(r(2)),
        o = r(5),
        i = r(4),
        s = r(3);

    e.submitResponse = function (e, r, a, u, c, l, f) {
      return new t(function (t, p) {
        if (!u && !o.findFirst(a.fields, function (t) {
          return !!t.time;
        })) return t();
        var h = o.checksum({
          exportables: a,
          actionables: u
        }, !0);
        h ? n.post(e + s.RESPONSE_ANNOUNCE).set(i.HEADER_RUNNER_TOKEN, r).send({
          fingerprint: a.fingerprint,
          checksum: h,
          runner: f
        }).then(function (f) {
          if (200 === f.status && f.body && f.body.id && f.body.difficulty) try {
            var h = o.castToString(f.body.id),
                d = o.castToNumber(f.body.difficulty),
                y = o.castToNumber(f.body.timestamp),
                m = o.powSolve({
              exportables: a,
              actionables: u
            }, d, h, 16, 3e5, y);
            n.post(e + s.RESPONSE_SUBMIT).set(i.HEADER_RUNNER_TOKEN, r).send({
              id: h,
              nonce: m,
              powDuration: o.powDuration(),
              powHashRate: o.powHashRate(),
              language: c,
              locale: l,
              exportables: a,
              actionables: u
            }).then(function (e) {
              200 === e.status && e.text ? t(e.text) : p(e.error && e.error.text || void 0);
            }).catch(function () {
              return p();
            });
          } catch (t) {
            p();
          } else p(f.error && f.error.text || void 0);
        }).catch(function () {
          return p();
        }) : p();
      });
    };
  }).call(this, r(0));
}, function (t, e, r) {
  "use strict";

  (function (t) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.deleteFile = e.uploadFile = e.downloadFile = void 0;

    var n = r(1).__importStar(r(2)),
        o = r(4),
        i = "/unconfirmed";

    e.downloadFile = function (e, r, i) {
      return new t(function (t, s) {
        n.get("" + e + "/unconfirmed/" + i).set(o.HEADER_RUNNER_TOKEN, r).responseType("blob").then(function (e) {
          200 === e.status ? t(e.body) : s();
        }).catch(function () {
          return s();
        });
      });
    }, e.uploadFile = function (e, r, i, s) {
      return new t(function (t, a) {
        var u = new FormData();
        u.append("file", i), n.post(e).set(o.HEADER_RUNNER_TOKEN, r).send(u).on("progress", function (t) {
          "upload" === t.direction && s(t.percent || 0);
        }).then(function (e) {
          var r;
          return 200 === e.status && (null === (r = e.body) || void 0 === r ? void 0 : r.name) ? t(e.body.name) : a(413 === e.status ? "File is too large." : void 0);
        }).catch(function () {
          return a();
        });
      });
    }, e.deleteFile = function (e, r, s) {
      return new t(function (t, a) {
        n.delete(e + i).set(o.HEADER_RUNNER_TOKEN, r).send({
          file: s
        }).then(function (e) {
          return 200 === e.status ? t() : a();
        }).catch(function () {
          return a();
        });
      });
    };
  }).call(this, r(0));
}]);